import { useQuery } from '@tanstack/react-query';
import { ReactNode, Suspense } from 'react';
import ManCityTemplate from 'ui/mancity/template';

import { getMainNav, getPrimaryNavItems } from 'services/mancity-template';

import { useBrowsing } from 'hooks/use-browsing';

import {
	PUBLIC_FF_HEADER_BASKET_ICON,
	PUBLIC_GTM_ID_ENV,
} from 'tools/environments';

import { queryKeys } from '@feed/queries/keys';

type LayoutProps = {
	children: ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
	const { query, isReady } = useBrowsing();
	const isFromApp = query.fromapp !== undefined;

	const mainNavQuery = useQuery({
		queryKey: queryKeys.layout.mainNav(),
		queryFn: () => getMainNav().then((response) => response.data),
		enabled: isReady && !isFromApp,
	});

	const navItems = isFromApp ? [] : getPrimaryNavItems(mainNavQuery.data);

	if (isFromApp) {
		return <>{children}</>;
	}

	return (
		<>
			<Suspense fallback={<>{children}</>}>
				<ManCityTemplate
					headerNavigationData={navItems}
					headerOnly
					config={{ gtmId: PUBLIC_GTM_ID_ENV }}
					showBasketIcon={PUBLIC_FF_HEADER_BASKET_ICON}
				>
					{children}
				</ManCityTemplate>
			</Suspense>
		</>
	);
};
